import React from 'react';
import InlineTextEditor from '@/components/common/InlineTextEditor';

export default function TextEditor(props) {
  return <InlineTextEditor {...props} label='notes' />;
}
